import ContentBox from '../ContentBox';

export default () => {
  return (
    <div style={{ height: "calc(95vh - 50px)" }}>
      <ContentBox style={{ height: "100%" }}>
        <iframe
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            position: "sticky",
            top: "0px",
            userSelect: "none",
          }}
          src="https://docs.google.com/document/d/1S4vEWp5EE2Qd1kl49F31KYQJRw2qzMBIixCgv2NGaFc/edit?usp=sharing"
        >
          IFRAME DESTEKLENMIYOR
        </iframe>
      </ContentBox>
    </div>
  );
};
